module.exports = __webpack_public_path__ + "static/media/bottom_banner_2_1.5759bd6d.png";